export default "__VITE_ASSET__DNfBIyNt__";